import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Head from '../../components/head';
import ItemBox from '../../components/itens/item';


function FolhaScreen() {
    return (
        <Fragment>
            <Head titulo="Recursos Humanos - Portal da Transparência da Prefeitura de Macuco" />
            <Header />
            <Container>
                <Row xs={1} lg={4}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Row xs={1} lg={3}>
                    <Col>
                        <ItemBox
                            titulo={"Folha de Pagamento"}
                            descricao={<Fragment>Clique aqui e veja a folha completa de cargos e remunerações deste município.<br /><br /></Fragment>}
                            awesome={"faMoneyCheck"}
                            link={"https://macuco.govbr.cloud/pronimtb/index.asp?acao=4&item=1"}
                        />
                    </Col>
                    <Col>
                        <ItemBox
                            titulo={"Estagiários"}
                            descricao={<Fragment>Clique aqui e veja a listagem de estagiários deste município.<br /><br /></Fragment>}
                            awesome={"faChalkboardUser"}
                            link={"folha/estagiarios"}
                        />
                    </Col>
                    <Col>
                        <ItemBox
                            titulo={"Terceirizados"}
                            descricao={<Fragment>Clique aqui e veja a listagem de funcionários terceirizados deste município.<br /><br /></Fragment>}
                            awesome={"faPeopleArrows"}
                            link={"folha/terceirizados"}
                        />
                    </Col>
                    <Col>
                        <ItemBox
                            titulo={"Concursos Públicos"}
                            descricao={<Fragment>Informações relacionadas aos concursos públicos e processos seletivos realizados pela Prefeitura de Macuco.<br /><br /></Fragment>}
                            awesome={"faFilePen"}
                            link={"folha/concursos"}
                        />
                    </Col>
                    <Col>
                        <ItemBox
                            titulo={"Tabela de Vencimentos - Efetivos"}
                            descricao={<Fragment>Veja aqui a tabela base de vencimentos dos Cargos Efetivos<br /><br /></Fragment>}
                            awesome={"faUserTie"}
                            link={"arquivos/docs/TABELA DE CARGOS - Efetivos - 2025.pdf"}
                        />
                    </Col>
                    <Col>
                        <ItemBox
                            titulo={"Tabela de Vencimentos - Professores"}
                            descricao={<Fragment>Veja aqui a tabela base de vencimentos dos Professores da Rede Municipal de Educação<br /><br /></Fragment>}
                            awesome={"faPersonChalkboard"}
                            link={"arquivos/docs/TABELA DE CARGOS - Professores - 2025.pdf"}
                        />
                    </Col>
                    <Col>
                        <ItemBox
                            titulo={"Tabela de Vencimentos - Comissionados"}
                            descricao={<Fragment>Veja aqui a tabela base de vencimentos dos Cargos Comissionados<br /><br /></Fragment>}
                            awesome={"faUserGroup"}
                            link={"arquivos/docs/TABELA DE CARGOS - Comissionados - 2025.pdf"}
                        />
                    </Col>
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default FolhaScreen;